import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { ModalComponent } from '../../../core/config/core.modal-helpers';
import { DocmanFileModel } from '../services/docman.model.file';
import { TagsModel } from '../../../core/services/core.models.tags.component';
import { MonitorService } from '../../../core/services/core.monitor.service';
import { UiService } from '../../../core/services/core.ui.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileVersionDeleteModalComponent } from '../fileVersionDeleteModal/file.version.delete.modal.controller';
import { FileVersionEditModalComponent } from '../fileVersionEditModal/file.version.edit.modal.controller';
import { FileVersionRestoreModalComponent } from '../fileVersionRestoreModal/file.version.restore.modal.controller';


@Component({
  selector: 'file-settings-edit-modal',
  template: require('./file.settings.edit.modal.html')
})
export class FileSettingsEditModalComponent extends ModalComponent implements OnInit, OnChanges {
  @Input() fileDetails: any;
  @Input() foldersFile: any;
  @Input() project: any;

  @Output() onEdit = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  activeTab: string = 'versions';
  settingsEdit: any = {
    file: null,
    showEdit: true
  };

  fileTags: any[] = [];
  tags: any[] = [];
  fileEdit: any;

  constructor(
    private docmanFileModel: DocmanFileModel,
    private tagsModel: TagsModel,
    private monitorService: MonitorService,
    private uiService: UiService,
    private modalService: NgbModal,
  ) {
    super();
  }

  ngOnInit() {
    this.fileEdit = _.cloneDeep(this.fileDetails);
    this.settingsEdit.file = this.fileEdit;

    this.tagsModel.load('docmanfile', this.fileEdit.id)
    .then(() => {
      this.tags = this.tagsModel.format(_.uniq(this.tagsModel.tags));
      this.setTagColors();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setTagColors();
  }

  setTagColors() {
    this.tags = _.map(
      _.get(this, 'tags', []),
      (tag: any) => {
        if (!tag.bgcolor) {
          tag.bgcolor = this.uiService.color.stringToClassColor(tag.text);
        }
        return tag;
      }
    );
  }

  setActiveTab(strTab: string) {
    this.uiService.setActiveTab(this, strTab);
  }

  editFileSettings() {
    let success = false;
    let folders: any[] = [];
    const fileName = this.fileEdit.fileName;
    folders = this.docmanFileModel.getAssignedFolders(folders, this.foldersFile[0]);
    
    let fileEditSave = _.cloneDeep(this.fileEdit);
    fileEditSave.rel = {
      folders: folders
    };

    this.docmanFileModel.saveFileSettings(fileEditSave)
      .then(response => {
        success = true;
        if (this.fileEdit.isMonitoring !== this.fileDetails.isMonitoring) {
          if (this.fileEdit.isMonitoring) {
            this.monitorService.set('docmanfile', this.fileEdit.id);
          } else {
            this.monitorService.unset('docmanfile', this.fileEdit.id);
          }
        }

        // Save the tags
        this.tagsModel.save('docmanfile', this.fileEdit.id, this.tagsModel.toString(this.tags));

        const fileDescription = _.get(this.fileEdit, 'description', '(unknown)');
        this.uiService.message.showSuccess(`File settings for ${fileDescription} have been updated successfully`);

        this.onEdit.emit(this.fileEdit);
      },() => {
        const fileDescription = _.get(this.fileEdit, 'description', '(unknown)');
        this.uiService.message.showError(`There was an error updating ${fileDescription}`);
      })
      .then(() => {
        this.closeModal();
      });
  }

  showDeleteFileVersion(fileVersion: any) {
    const modalRef = this.modalService.open(FileVersionDeleteModalComponent);
    modalRef.componentInstance.fileVersion = fileVersion;
    modalRef.componentInstance.onDelete.subscribe((params) => {
      this.deleteFileVersionCallback(params)
	    modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
	    modalRef.close();
    });
  }

  deleteFileVersionCallback(fileVersion: any) {
    _.remove(this.fileEdit.rel.versions, { id: fileVersion.id });
    if (this.fileEdit.rel.versions.length === 0) {
      this.onEdit.emit(true);
    }
  }

  showEditFileVersion(fileVersion: any) {
    const modalRef = this.modalService.open(FileVersionEditModalComponent);
    modalRef.componentInstance.file = this.fileDetails;
    modalRef.componentInstance.fileVersion = fileVersion;
    modalRef.componentInstance.onEdit.subscribe(() => {
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
        modalRef.close();
    });
  }

  showRestoreFileVersion(fileVersion: any) {
    const modalRef = this.modalService.open(FileVersionRestoreModalComponent);
    modalRef.componentInstance.fileVersion = fileVersion;
    modalRef.componentInstance.onRestore.subscribe(() => {
      modalRef.close();
    });
    modalRef.componentInstance.onClose.subscribe(() => {
        modalRef.close();
    });
  }

  openImage(url: string) {
    const openUrl = `${url}/open`;
    window.open(openUrl, '_blank');
  }

  doCloseModal() {
    this.onClose.emit();
  }
}

